const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const moment = require("moment");
const ButtonWithConfirm = require("../office/ButtonWithConfirm");

const styles = require("./styles/ReportTestUnlockPanel.css");

module.exports = createReactClass({
	displayName: "ReportTestUnlockPanel",

	propTypes: {
		unlocked: PT.bool.isRequired,
		startsAt: PT.string,
		startResolution: PT.string,
		onUnlock: PT.func,
	},

	onClickUnlock: function() {
		this.props.onUnlock();
	},

	render: function() {
		const {unlocked, startsAt, startResolution} = this.props;

		let button = null;
		if (!unlocked) {
			const confirmWarning =
				"You are about to manually unlock this test. " +
				"Once unlocked, it cannot be locked again. " +
				"Are you sure you want to do this?";
			button = (
				<ButtonWithConfirm
					className={styles.button}
					buttonText="Unlock"
					confirmWarning={confirmWarning}
					modalButtonTexts={["unlock test", "keep locked"]}
					modalRedButtonIndices={[0]}
					onClick={this.onClickUnlock}
					closeOnPending={true}
				/>
			);
		}

		let renderedStart = null;
		if (!unlocked) {
			const startM = moment(startsAt);
			renderedStart = "Unlocks automatically ";
			renderedStart += startResolution
				? "within " + startResolution + " of "
				: "";
			renderedStart += startM.format("llll");
		}

		return (
			<div className={styles.main}>
				<div className={styles.statusContainer}>
					Status: <strong>{unlocked ? "Unlocked" : "Locked"}</strong>
				</div>
				<div className={styles.buttonContainer}>{button}</div>
				<div className={styles.timeContainer}>{renderedStart}</div>
			</div>
		);
	},
});
